<mat-progress-bar
  class="history-progress-bar"
  color="primary"
  [mode]="progressMode$ | async"
  [value]="progressPercent$ | async"
></mat-progress-bar>
<span [matTooltip]="progressTooltip$ | async">
  {{ progressText$ | async }}
</span>
